export default __webpack_public_path__ + "static/media/logoWhite.06ec1420.png";